import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";

function UnauthorizedPage(props) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Unauthorized
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You are not authorized to access this page.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={() => navigate(-1)}>Back</Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnauthorizedPage;